import React, {
  useState,
  createRef,
  useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import ArrowFowardIcon from '@material-ui/icons/ArrowForwardIosRounded';
import { Collapse } from 'react-collapse';
import { withStyles } from '@material-ui/core/styles';
import {
  ArrowContainer,
  ParticipantChoicesFilter,
} from './ParticipantFilterComponents';

const MobileHallFilterContainer = styled.div`
  width: 100%;
  background-color: #FFF;
  border-bottom: 0.5px solid #DBDEE2;
  position: relative;
  z-index: 2;

  @media only screen and (min-width: 960px) {
    display: none;
  }
`;

const MobileFilterWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`;

const MobileFilterOption = styled.div`
  padding: 12px 8px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  color: #999;

  @media only screen and (max-width: 370px) {
    font-size: 11px;
  }
`;

const MobileFilterSelectContainer = styled.div`
  width: 100%;
  padding: 8px;
  transition: all 0.3s;
`;

const ButtonContainer = styled.div`
  width: 100%;
  padding: 20px 16px;
  display: inline-flex;
  justify-content: space-between;
  margin-top: 16px;
`;

const GreyBackground = styled.div`
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const FunctionButton = ({ children, ...props }: any) => {
  const Custom = withStyles(() => ({
    containedPrimary: {
      textTransform: 'capitalize',
      backgroundColor: props.isClearAll ? '#F0F1F2' : '#F5415B',
      color: '#000',
      flex: '1 0 auto',
      marginLeft: props.isClearAll ? 'unset' : '20px',
      '&:hover': {
        backgroundColor: '#F0F1F2',
      },
    },
  }))(Button);
  return <Custom {...props as any}>{children as any}</Custom>;
};

const BottomButtonContainer = (
  {
    handleResetClicked,
    handleApplyClicked,
  }: any,
) => {
  const { t } = useTranslation();

  return (
    <ButtonContainer>
      <FunctionButton
        variant="contained"
        color="primary"
        onClick={handleResetClicked}
        isClearAll
      >
        {t('filter.clear_all', 'Clear All')}
      </FunctionButton>
      <FunctionButton
        variant="contained"
        color="primary"
        onClick={handleApplyClicked}
        isClearAll={false}
      >
        {t('filter.show_results', 'Show Results')}
      </FunctionButton>
    </ButtonContainer>
  );
};

const ParticipantMobileFilter = ({
  questions,
  onChoiceSelect,
  resetSelectedChoices,
  applyClickedOptions,
  handleQuestionOpen,
  isLoading,
  mobileParticipantFilter,
}: any) => {
  const { t } = useTranslation();
  const [openTab, setOpenTab] = useState(false);
  const filterRef = createRef<HTMLDivElement>();

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        if (openTab) {
          setOpenTab(false);
          resetSelectedChoices();
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [filterRef, openTab, resetSelectedChoices]);

  const handleApplyClicked = () => {
    applyClickedOptions();
    setOpenTab(false);
  };

  const handleResetClicked = () => {
    resetSelectedChoices();
  };

  return (
    <>
      {openTab && <GreyBackground />}
      <MobileHallFilterContainer ref={filterRef}>
        <MobileFilterWrapper>
          <MobileFilterOption onClick={() => setOpenTab((prev) => !prev)}>
            {t('filter.title', 'Filter')}
            <ArrowContainer selected={openTab}>
              <ArrowFowardIcon style={{ fontSize: '12px' }} />
            </ArrowContainer>
          </MobileFilterOption>
        </MobileFilterWrapper>
        <Collapse isOpened={openTab}>
          <MobileFilterSelectContainer>
            <ParticipantChoicesFilter
              questions={questions}
              onChoiceSelect={onChoiceSelect}
              isRootQuestion
              handleQuestionOpen={handleQuestionOpen}
              isLoading={isLoading}
              mobileParticipantFilter={mobileParticipantFilter}
              isDesktop={false}
            />
            <BottomButtonContainer handleResetClicked={handleResetClicked} handleApplyClicked={handleApplyClicked} />
          </MobileFilterSelectContainer>
        </Collapse>
      </MobileHallFilterContainer>
    </>
  );
};

export default ParticipantMobileFilter;
